// eslint-disable-next-line import/extensions
import Inputmask from 'inputmask/lib/inputmask.js';

export default {
  install(app) {
    app.directive('mask', {
      mounted(el, binding) {
        if (binding.value) {
          Inputmask(binding.value).mask(el);
        }
      }
    });
  }
};
